import { useParams, useSearchParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const MAGAZINE_TYPE_ARRAY = [
	{ type: "Plan", label: "プラン" },
	{ type: "Room", label: "部屋" },
	{ type: "AboutHotel", label: "施設" },
] as const;
export const MAGAZINE_RESOURCE_TYPE_ARRAY = MAGAZINE_TYPE_ARRAY.map((item) => item.type);
export type MAGAZINE_RESOURCE_TYPE = (typeof MAGAZINE_TYPE_ARRAY)[number]["type"];

export const MAGAZINE_RESOURCE_ID_PARAMS = "resourceID";
export const MAGAZINE_RESOURCE_TYPE_PARAMS = "type";

type MagazinePageParams =
	| {
			hotelID: string;
			magazineResourceID: undefined;
			magazineResourceType: "AboutHotel";
	  }
	| {
			hotelID: string;
			magazineResourceID: string;
			magazineResourceType: "Plan" | "Room";
	  };

export const useGetMagazinePageParams = (): MagazinePageParams => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.EDIT.DEFAULT>>();
	const [searchParams] = useSearchParams();

	const magazineResourceID = searchParams.get(MAGAZINE_RESOURCE_ID_PARAMS);
	const magazineResourceType = searchParams.get(MAGAZINE_RESOURCE_TYPE_PARAMS) as MAGAZINE_RESOURCE_TYPE | null;

	if (!hotelID) {
		notifyUserEventInfo({
			title: "ホテルIDが取得できませんでした",
		});
	}

	if (!magazineResourceType) {
		notifyUserEventInfo({
			title: "正しくないURLです",
		});
	}

	if (magazineResourceType === "AboutHotel") {
		return {
			hotelID: hotelID!,
			magazineResourceID: undefined,
			magazineResourceType,
		};
	}

	if (!magazineResourceID) {
		notifyUserEventInfo({
			title: "正しくないURLです",
		});
	}

	return {
		hotelID: hotelID!,
		magazineResourceID: magazineResourceID!,
		magazineResourceType: magazineResourceType!,
	};
};
